import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=4c81ea7a"
import script from "./Permissions.vue?vue&type=script&lang=js"
export * from "./Permissions.vue?vue&type=script&lang=js"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=4c81ea7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d0d1c26b22fe14fd22da96c4620a1900/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports